import { Box, CircularProgress, Modal } from "@mui/material";

const OpaqueModal = ({
  isModalOpen,
  // setIsModalOpen,
  rootContainerRef
}) => {
  return (
    isModalOpen ? <Modal
      open={true} 
      // onClose={() => {
      //   // setIsModalOpen(false);
      // }}
      disablePortal
      BackdropProps={{
        sx: {
          position: "absolute", // relative to container
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
      }}
      sx={{
        position: "absolute", // ✅ relative to parent container
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      container={rootContainerRef.current}
    >
      <Box>
        <CircularProgress size={50} />
      </Box>
    </Modal> : null
  )
};

export default OpaqueModal;